import React from "react";
import { Box, Flex, Text, Heading } from "rebass/styled-components";

import Icon from "../common/Icon";

import useTranslation from "next-translate/useTranslation";

const HowItWorks = () => {
  const { t } = useTranslation("sitterprofile");

  const items = [
    {
      icon: <Icon name="eye" color="inuOrange" fontSize={7}></Icon>,
      title: t("howItWorks1Title"),
      description: t("howItWorks1Desc")
    },
    {
      icon: <Icon name="av_calendar" color="inuOrange" fontSize={7}></Icon>,
      title: t("howItWorks2Title"),
      description: t("howItWorks2Desc")
    },
    {
      icon: <Icon name="sitter" color="inuOrange" fontSize={7}></Icon>,
      title: t("howItWorks3Title"),
      description: t("howItWorks3Desc")
    },
    {
      icon: <Icon name="feeder" color="inuOrange" fontSize={7}></Icon>,
      title: t("howItWorks4Title"),
      description: t("howItWorks4Desc")
    }
  ];

  return (
    <Box maxWidth="750px">
      <Heading as="h2" fontSize={5} fontWeight="book" mb={4}>
        {t("howItWorks")}
      </Heading>

      <Box>
        {items.map(item => {
          return (
            <Flex mb={2}>
              <Box mr={2} flexShrink={0}>
                {item.icon}
              </Box>
              <Box>
                <Text fontWeight="bold">{item.title}</Text>
                <Text>{item.description}</Text>
              </Box>
            </Flex>
          );
        })}
      </Box>
    </Box>
  );
};

export default HowItWorks;
